import React, { useState, useRef, useEffect, useCallback } from 'react';
import * as Colors from '../../../styles/colors';
import { AsyncTypeahead, Menu, MenuItem, Highlighter } from 'react-bootstrap-typeahead';
import TailOption from './TailOption';
import {
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { buttonBackground } from '../../../styles/colors';
import { TAIL_LOOKUP, TAILS_LOOKUP } from './queries';
import { useMutation, useLazyQuery } from '@apollo/client';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import ReactDOM from "react-dom";
import './styles.css';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const lookupInputContainer = {
  display: 'inline-flex',
  flex: 1,
  alignItems: 'flex-end'
}

const tailOptionContainer = {
  // display: 'flex',
  // flex: 1,
  // borderBottom: '1px solid #ccc',
  // marginTop: '0px',
  backgroundColor: '#EFEFEF',
}

const lookupInput = {
  borderRadius: '6px 0px 0px 6px',
  padding: '0px',
  fontSize: '1rem',
  backgroundColor: '#EFEFEF',
  border: 'none',
  width: '100%',
  paddingLeft: '30px',
  color: 'black',
  height: '1.89rem'
}

const newLookupInput = {
  borderRadius: '6px 0px 0px 6px',
  padding: '0px',
  fontSize: '1rem',
  backgroundColor: '#EFEFEF',
  border: 'none',
  width: '250px',
  paddingLeft: '30px',
  color: 'black',
  marginTop: '5px'
  // height: '2.75rem'
}

const Icon = styled(FontAwesomeIcon)`
  margin-right: 12px;
  font-weight: 500;
  color: ${buttonBackground};
`;

const Search = styled.div`
  margin-top: 36px;
  margin-left: -5px;
  z-index: 100;
  border: 0px;
  background-color: ${buttonBackground};
  border-radius: 0px 6px 6px 0px;
  color: white;
  font-size: 1.25rem;
  padding: 12px;
  @media (max-width: 768px) {
    font-size: 1.25;
    padding: 12px;
    white-space: nowrap;
  }
`;

const TailLookupInput = (props) => {
  const {
    foundTail,
    setFoundTail,
    setFoundOperator,
    foundTailNumberBackup,
    setFoundTailNumberBackup,
    currentInput,
    setCurrentInput
  } = props;
  const foundTailNumber = foundTail !== '' ? foundTail.tailNumber : '';
  const [selectedTail, setSelectedTail] = useState('');
  const [term, setTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [menuOptions, setMenuOptions] = useState([]);
  const [typing, setTyping] = useState(false);
  const tailLookupInput = useRef(null);
  const [requery, setRequery] = useState(true);
  const hideMenu = () => {
    tailLookupInput.current.hideMenu();
    tailLookupInput.current.clear();
  }

  const [
    tailsLookup,
    { loading, data },
  ] = useLazyQuery(TAILS_LOOKUP);

  const handleLookup = (query) => {
    if(query === foundTailNumber && !requery) {
      setRequery(true)
    }else {
      setRequery(false)
    }
    if(query?.length >=3) {
      setIsLoading(true)
      tailsLookup({ variables: { term: query }})
    }
  }

  const [
    tailLookup,
    { loading: tailLoading, data: tailData },
  ] = useLazyQuery(TAIL_LOOKUP);

  const selected = (option) => {
    // setCurrentInput('')
    let menuOption = menuOptions.find(mOption =>
      mOption.id === option.id
    )

    // if (option && option?.id) {
    if(menuOption) {
      // setSelectedTail(option)
      setSelectedTail(menuOption)
      // tailLookup({ variables: { id: option.id } })
      tailLookup({ variables: { id: menuOption.id } })
      // setCurrentInput('tail')
      // setFoundOperator('')
    }
  }

  useEffect(() => {
    if (data && data.tailsLookup && isLoading) {
      if(menuOptions !== data.tailsLookup) {
        setIsLoading(false)
        setMenuOptions([])
        let mOptions = data.tailsLookup
        setMenuOptions(mOptions)
      }
    }
  }, [data, loading]);

  useEffect(() => {
    if (tailData && tailData.tailLookup) {
      setFoundTail(tailData.tailLookup)
      setCurrentInput('tail')
      setIsLoading(false)
    }
  }, [tailData, tailLoading]);

  const filterBy = () => true;

  const getEmptyResults = () => {
    return <span style={{fontWeight: 'bold', color: 'red'}}>No Tails Found</span>
  }

  return (
    <div className="lookup-input-container" style={lookupInputContainer}>

      {/*<AsyncTypeahead
        id="lookup-input"
        filterBy={filterBy}
        isLoading={isLoading}
        labelKey={option => `${option.tailNumber}`}
        size='large'
        useCache={false}
        onSearch={query => {
          setTerm(query)
          handleLookup(query)
        }}
        // onInputChange={query => setTerm(query)}
        onFocus={(event) => {
          if(requery) {
            handleLookup(event.target.value)
          }
        }}
        options={menuOptions}
        emptyLabel={getEmptyResults()}
        defaultInputValue={foundTailNumber}
        renderMenuItemChildren={(option, props, idx) => {
          return (
            <TailOption option={option} selected={selected}/>
          )
        }}
        inputProps={{
          style: lookupInput
        }}
      />*/}
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={menuOptions.map(option => {
          return {label: option.tailNumber, id: option.id}
        })}
        // getOptionLabel={option => option.label}
        sx={newLookupInput}
        onInputChange={event => handleLookup(event?.target?.value)}
        filterOptions={(x) => x}
        onChange={(event, newValue) => selected(newValue)}
        noOptionsText={getEmptyResults()}
        onFocus={(event) => {
          // if(requery) {
            // handleLookup(event.target.value)
          // }
        }}
        // defaultValue={foundTailNumber}
        renderInput={(params) => {
          return <TextField {...params} label="Tail Number" variant="outlined" />
        }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.label}
            </li>
          )
        }}
      />
      <Search>
        <Icon icon={faMagnifyingGlass} style={{color: 'white'}}/>
        Tail Number
      </Search>
    </div>
  )
}

export default TailLookupInput;
